/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Manage_Webhooks_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to create, edit or delete webhooks, which can post messages from other apps or sites into this server." |
*
* @param {Leveling_Perm_Manage_Webhooks_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_manage_webhooks_hint = /** @type {((inputs?: Leveling_Perm_Manage_Webhooks_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Manage_Webhooks_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам создавать, изменять и удалять вебхуки. Вебхуки публикуют на сервере сообщения из других приложений и сайтов.")
	return /** @type {LocalizedString} */ ("Allows members to create, edit or delete webhooks, which can post messages from other apps or sites into this server.")
});